import { render, staticRenderFns } from "./ShowContenidoBookCharTab.vue?vue&type=template&id=68d3cd88&scoped=true"
import script from "./ShowContenidoBookCharTab.vue?vue&type=script&lang=js"
export * from "./ShowContenidoBookCharTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d3cd88",
  null
  
)

export default component.exports